import React from 'react';
import { Box, Text, WarningLabel } from '@common-fe/common-fe';
import { createGlobalStyle } from 'styled-components';

export const FRAUD_THRESHOLD_ANCHOR_CLASS = 'fraud-threshold-anchor-wrap';
const FraudThresholdAnchorStyle = createGlobalStyle`
  .${FRAUD_THRESHOLD_ANCHOR_CLASS} {
    position: static !important;
  }
`;

const FraudThresholdHeader: React.FC = () => (
  <Box gap="spacing16" id="fraud_threshold">
    <FraudThresholdAnchorStyle />
    <Box gap="spacing2">
      <Text weight={400} size="xxlarge" color="textBody" style={{ lineHeight: '28px' }}>
        Fraud Risk Review Thresholds
      </Text>
      <Text weight={400} size="medium" color="textBody">
        Daily and weekly threshold calculations take into account all reimbursements
        and payments made within the preceding 24 hours or 7 days, including claims
        that have already been paid. If the thresholds are left blank, monitoring
        will not occur.
      </Text>
    </Box>
    <Box
      background={{ color: 'warningContainer' }}
      border={{ size: '1px', color: 'warningBorder' }}
      round="container2Round"
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      <Box round="smallRound" height="2px" background="warning" />
      <Box pad={{ horizontal: 'spacing24', vertical: 'spacing16' }}>
        <WarningLabel>
          <Text weight={700} size="medium" color="textBody">
            Avoid setting low thresholds to prevent automatic payment holds on valid claims.
          </Text>
        </WarningLabel>
      </Box>
    </Box>
  </Box>
);

export default FraudThresholdHeader;
